//      
export default (el          )                =>
  el && el.ownerDocument ? el.ownerDocument.defaultView : window;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/window/get-window-from-el.js